module.exports = __webpack_public_path__ + "i18n/es.b063a6e5f181f473534b0844dd4d832f.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 1306
// module chunks = 59